module.exports = "pegasus/assets/blocks/capture-2-themecapture1.png";